import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950" aria-label="页脚">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="text-2xl font-black font-heading text-primary-400 tracking-tight">51</span>
                <span className="text-lg font-bold font-heading text-background-50">影院</span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed">{siteInfo.description}</p>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">影视分类</h4>
              <div className="flex flex-col gap-2">
                {categories.map(cat => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-background-400 text-sm hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">友情链接</h4>
              <div className="flex flex-col gap-2">
                <span className="text-background-400 text-sm">6080影院</span>
                <span className="text-background-400 text-sm">小a影院</span>
                <span className="text-background-400 text-sm">8090影院</span>
                <span className="text-background-400 text-sm">4480影院</span>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4 text-sm">联系我们</h4>
              <div className="flex flex-col gap-2 text-background-400 text-sm">
                <span>{siteInfo.email}</span>
                <span>{siteInfo.phone}</span>
                <span>{siteInfo.address}</span>
              </div>
              <div className="flex gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">&copy; {siteInfo.year} 51影院. All Rights Reserved.</p>
          <div className="flex gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}